/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_appsync_graphqlEndpoint": "https://udf3i2lpnjcxrg7ila7q2vgtxi.appsync-api.ap-northeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-northeast-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "ap-northeast-1:4681d7ec-4afb-4785-9615-cb1be70a6907",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_svHHorUPd",
    "aws_user_pools_web_client_id": "3epc2rrqjd4757ul8ns38acvov",
    "oauth": {
        "domain": "reactamplified0d8d91e2-0d8d91e2-prod.auth.ap-northeast-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://www.one-diary.com/,http://localhost:3000/,https://staging.d2phxtblkmxiiy.amplifyapp.com/,https://dev.d2phxtblkmxiiy.amplifyapp.com/",
        "redirectSignOut": "https://www.one-diary.com/,http://localhost:3000/,https://staging.d2phxtblkmxiiy.amplifyapp.com/,https://dev.d2phxtblkmxiiy.amplifyapp.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "reactamplified7ea9fa6ce32c4e96970c29ae2aa5573084944-prod",
    "aws_user_files_s3_bucket_region": "ap-northeast-1"
};


export default awsmobile;
